import { Injectable } from '@angular/core';

import { finalize, map, Observable } from 'rxjs';

import { TeamContact } from '@reg/shared/model';
import { TeamService } from '@reg/shared/service';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get and save TeamContact data.
 */
@Injectable()
export class TeamContactService {
    /**
     * Constructor
     */
    constructor(
                private http: HttpServiceHelper,
                private teamService: TeamService,
    ) {
    }

    /**
     * Add or update the TeamContact
     */
    public save(teamContact: TeamContact, includes: string[] = null): Observable<TeamContact> {
        let response: Observable<IJsonApiResponse>;
        const apiRequestUrl: string = this.getApiUrl(teamContact.eventId, teamContact.teamId, teamContact.id, includes);

        if (teamContact.id) {
            // Update existing TeamContact
            response = this.http.patch(apiRequestUrl, teamContact.serialize());
        } else {
            // Add a new TeamContact
            response = this.http.post(apiRequestUrl, teamContact.serialize());
        }

        return response
            .pipe(
                map((response: IJsonApiResponse) => (new TeamContact()).deserialize(response)),
                finalize(() => this.teamService.clearCache()),
            );
    }

    /**
     * Delete the specified TeamContact.
     */
    public delete(teamContact: TeamContact): Observable<boolean> {
        const apiRequestUrl: string = this.getApiUrl(teamContact.eventId, teamContact.teamId, teamContact.id);

        const response: Observable<Object> = this.http.delete(apiRequestUrl);

        return response
            .pipe(
                map(() => true),
                finalize(() => this.teamService.clearCache()),
            );
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(
        eventId: string,
        teamId: string,
        teamContactId: string,
        includes: string[] = null,
        queryParams: string[] = null,
    ): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/events/${eventId}/teams/${teamId}/contacts/`;

        if (teamContactId) {
            url += teamContactId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
